export default __webpack_public_path__ + "static/media/lunch.ebb8d55b.svg";